import React from "react";
import { node, bool, string } from "prop-types";
import { PageContainer } from "./PageContainer";
import { HeaderContainer } from "./HeaderContainer";
import { Logo } from "./Logo/Logo";
import { ContentContainer } from "./ContentContainer";
import { Footer } from "./Footer/Footer";
import { FooterLink } from "./Footer/FooterLink";

export function Layout({ children, centerContent, description }) {
  return (
    <PageContainer>
      <header>
        <HeaderContainer>
          <Logo />
          <span>{description}</span>
        </HeaderContainer>
      </header>
      <ContentContainer $isCentered={centerContent}>
        {children}
      </ContentContainer>
      <Footer>
        <FooterLink href="mailto:soltysiak.wojciech@gmail.com" target="_blank">
          Napisz do mnie
        </FooterLink>
      </Footer>
    </PageContainer>
  );
}

Layout.propTypes = {
  children: node.isRequired,
  centerContent: bool,
  description: string.isRequired,
};

Layout.defaultProps = {
  centerContent: false,
};
